export default __webpack_public_path__ + "static/media/img-guide-gt-popup-1-na_en.663290ad.png";